//
// Go to Top.js
//

setTimeout(() => {
  const $body = document.documentElement;
  const footerWrap = document.querySelectorAll('.go-top');

  footerWrap.forEach(($e) => {
    const goTop = $e;
    function backToTop() {
      $body.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
    goTop.addEventListener('click', backToTop);
  });

  document.addEventListener('scroll', () => {
    if (footerWrap.length > 0) {
      const topBtn = document.querySelector('.go-top');
      if (window.scrollY > 400) {
        topBtn.style.display = 'inline';
      } else {
        topBtn.style.display = 'none';
      }
    }
  });
}, 1000);
